import { branch, compose, renderComponent } from "recompose"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import { ClearbitRevealLivePreview } from 'components/ClearbitRevealPreview'
import { getClearbitRevealContext } from 'app/modules/enrichment/clearbit/selectors'
import { isConnectedTo } from 'app/modules/integrations/selectors'
import NoCompanyInfo from "../CompanyInfo/NoCompanyInfo"
import CompanyInfoModal from "../CompanyInfo"
import NewCompanyInfo from "../CompanyInfo/newCompanyInfo"

import * as GateSelectors from 'app/modules/gates/selectors'


const makeMapStateToProps = () => {

  return (state, props) => {
    const revealContext = getClearbitRevealContext(state)
    const hasDemandbase = isConnectedTo(state, 'demandbase')
    const canUseCompanyTags = GateSelectors.canUseCompanyTags(state)

    return {
      companyInfo: props.company,
      revealContext,
      hasDemandbase,
      canUseCompanyTags
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
  }, dispatch),
})

const CompanyTab = compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  branch(props => !props.hasDemandbase && props.revealContext.isEligibleForLiveRevealUpgradeFlow, renderComponent(ClearbitRevealLivePreview)),
  branch(props => (!props.companyInfo || !props.companyInfo.name) && !props.endUserId, renderComponent(NoCompanyInfo)),
  branch(props => props.endUserId, renderComponent(NewCompanyInfo)),
)(CompanyInfoModal)

export default CompanyTab



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/CompanyTab/index.js